import { ContentCard } from 'ypf-pas-general-ui-components';
import { GrLocation } from 'react-icons/gr';

const NoUbications = () => (
  <>
    <ContentCard className="icon-clipboard-container" orientation="horizontal">
      <GrLocation />
    </ContentCard>
    <p>
      <strong>No disponés de ninguna ubicacion para el parte de trabajo</strong>
    </p>
    <p>Agregá ubicaciones para relacionarlas luego con las líneas del parte de trabajo.</p>
  </>
);

export default NoUbications;
